import React, { useEffect, useRef, useState, useReducer } from "react";
import ReactDOM from "react-dom";
import eventBus from "../../../../../util/eventBus";
import "./index.less";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import { useSize, useFullscreen } from "ahooks";
import { Icon } from "@kdcloudjs/kdesign";
/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */

(function (KDApi) {
  function talentCalibration(model) {
    this._setModel(model);
  }

  talentCalibration.prototype = {
    _setModel: function (model) {
      this.model = model;
      this.I18N = (key) => KDApi.getLangMsg(model, key);
    },
    init: function (props) {
      console.log("-----init", this.model.style, props);
      setHtml(this.model, props, { I18N: this.I18N });
    },
    update: function (props) {
      console.log("-----update", this.model, props);
      eventBus.pub(this.model, "update", props);
    },
    destoryed: function () {
      console.log("-----destoryed", this.model);
      ReactDOM.unmountComponentAtNode(this.model.dom);
    },
  };

  var setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      const Root = (props) => {
        const [model, setModel] = useState(props.model);
        const [customProps, setCustomProps] = useState(props.customProps);
        const initState = {
          I18N: props.I18N,
          model: props.model,
          globalData: props.customProps?.data?.data,
          isEdit: props.customProps?.data?.pageStatus !== "view",
          openedKeys: props.customProps?.data?.data?.[0]?.id
            ? [props.customProps?.data?.data?.[0]?.id]
            : [],
          activeKey:
            props.customProps?.data?.activeKey ||
            props.customProps?.data?.data[0]?.id,
        };
        const [store, setStore] = useState(initState);
        const { openedKeys, activeKey, isEdit, globalData } = store;
        console.log(store);
        useEffect(() => {
          const updateSub = eventBus.sub(model, "update", (customProps) => {
            console.log("校准会传输过来的数据", customProps);
            setCustomProps(customProps);

            if (customProps.data.eventName === "modify") {
              const { type, id, text } = customProps.data.data;
              if (type === "changeText") {
                const data = globalData.map((item) => {
                  if (item.id === id) {
                    item.text = text;
                  } else {
                    item.children = item.children.map((subItem) => {
                      if (subItem.id === id) {
                        subItem.text = text;
                      }
                      return subItem;
                    });
                  }
                  return item;
                });
                data.setStore((d) => ({ ...d, globalData: data }));
              }
              if (type === "delete") {
                deleteItem(id);
              }
            } else {
              customProps?.data?.data &&
                setStore((data) => ({
                  ...data,
                  globalData: customProps?.data?.data,
                  activeKey: customProps?.data?.activeKey,
                  isEdit: customProps?.data?.pageStatus !== "view",
                }));
            }
          });
          return () => {
            eventBus.unsub(updateSub);
          };
        }, []);

        const deleteItem = (id) => {
          const result = [];

          globalData.forEach((item) => {
            if (item.id !== id) {
              const children =
                item.children.filter((subItem) => subItem.id !== id) || [];
              result.push({ ...item, children });
            }
          });
          setStore((d) => ({ ...d, globalData: result }));
        };

        const onSubMenuClick = (id) => {
          model.invoke("modify", { type: "click", id });
          const index = store.openedKeys.indexOf(id);
          if (index === -1) {
            setStore((data) => ({
              ...data,
              openedKeys: [...data.openedKeys, id],
            }));
          } else {
            const openedKeys = [...store.openedKeys];
            openedKeys.splice(index, 1);
            setStore((data) => ({
              ...data,
              openedKeys,
            }));
          }
        };
        const onItemClick = (id) => {
          model.invoke("modify", { type: "click", id });
          setStore((data) => ({ ...data, activeKey: id }));
        };

        const generateEditAndDelete = ({ id, showEditBtn, showDeleteBtn }) => {
          return (
            <>
              {showEditBtn && (
                <Icon
                  type="edit-border"
                  onClick={(e) => {
                    e.stopPropagation();
                    model.invoke("modify", { type: "edit", id });
                  }}
                />
              )}
              {showDeleteBtn && (
                <Icon
                  type="delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    model.invoke("modify", { type: "delete", id });
                  }}
                />
              )}
            </>
          );
        };

        const generateMenu = (data) => {
          const { children, text, id, parentId, showDeleteBtn, showEditBtn } =
            data;
          return children && children?.length ? (
            <div className="sub-menu" key={id}>
              <div
                className={[
                  "sub-menu-title-wrapper",
                  activeKey === id ? "sub-menu-title-wrapper-active" : "",
                ].join(" ")}
              >
                <Icon
                  type={
                    openedKeys?.includes(id)
                      ? "arrow-down-solid"
                      : "arrow-right-solid"
                  }
                  onClick={() => onSubMenuClick(id)}
                />
                <div className="sub-menu-title" onClick={() => onItemClick(id)}>
                  <div className="menu-item-title single-line">{text}</div>
                  {generateEditAndDelete(data)}
                </div>
              </div>
              {store?.openedKeys.includes(id) ? (
                <div style={{ width: "100%" }}>
                  {children.map(({ id, text, showDeleteBtn, showEditBtn }) => (
                    <div
                      className={
                        activeKey === id
                          ? "menu-item-active menu-item"
                          : "menu-item"
                      }
                      style={{
                        paddingLeft: "50px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      key={id}
                      onClick={() => onItemClick(id)}
                    >
                      <div className="menu-item-title single-line">{text}</div>
                      {generateEditAndDelete({
                        id,
                        showDeleteBtn,
                        showEditBtn,
                      })}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ) : (
            <div
              className={
                store.activeKey === id
                  ? "menu-item-active menu-item"
                  : "menu-item"
              }
              style={{ paddingLeft: "25px" }}
              key={id}
              onClick={() => onItemClick(id)}
            >
              <div className="menu-item-title single-line">{text}</div>
              {generateEditAndDelete(data)}
            </div>
          );
        };
        return store.globalData ? (
          <div
            className="calibration-tree-container"
            id={"calibration-tree-container" + model.pageId}
          >
            <div className="calibration-tree-main">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                {globalData.map((item) => generateMenu(item))}
              </div>
            </div>
          </div>
        ) : null;
      };

      ReactDOM.render(
        <Root model={model} customProps={primaryProps} I18N={I18N} />,
        model.dom
      );
    });
  };

  // 注册自定义组件
  KDApi.register("talentCalibrationMenu", talentCalibration, {
    isMulLang: true,
  });
})(window.KDApi);
